import { render, staticRenderFns } from "./BoosterPurchaseList.vue?vue&type=template&id=56c8ba40&scoped=true"
import script from "./BoosterPurchaseList.vue?vue&type=script&lang=js"
export * from "./BoosterPurchaseList.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/table-admin-styles.css?vue&type=style&index=0&id=56c8ba40&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c8ba40",
  null
  
)

export default component.exports